import React from 'react'
import '../../css/Education.css'
const Education = () => {
  return (
    <div className="education">
      <div className="edu btech">
        <div className="logo"></div>
        <div className="eduDetails">I.K. Gujral Punjab Technical University
        <div className="grade">8.44 CGPA</div>
        </div>
      </div>
      <div className="edu th12">
      <div className="logo"></div>
        <div className="eduDetails">DAV Kapildev Ranchi
        <div className="grade">91.6%</div>
        </div>
        

      </div>
      <div className="edu th10">
      <div className="logo"></div>
        <div className="eduDetails">St. Francis School, Ranchi
        <div className="grade">91.2%</div>
        </div>
        

      </div>
    </div>
    )
}

export default Education